import { RootState } from '@store/rootReducer'

export const selectAIFashionModels = (state: RootState) => state.editor.aiFashionModelReducer.aiFashionModels
